/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const DataIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    onClick={props.onClick}
    viewBox="0 0 60 66"
  >
    <g fill="none">
      <g strokeWidth="2" transform="translate(.75 1.5)">
        <ellipse cx="29.25" cy="12" rx="28.5" ry="12" />
        <path d="M57.747 24c0 6.63-12.762 12-28.5 12S.747 30.63.747 24M57.747 37.5c0 6.63-12.762 12-28.5 12s-28.5-5.37-28.5-12" />
        <path d="M.747 12v39c0 6.63 12.762 12 28.5 12s28.5-5.37 28.5-12V12" />
      </g>
    </g>
  </svg>
);

export default DataIcon;
